import { useState, useRef } from 'react';

//3rd party
import * as Icon from 'react-bootstrap-icons';
import Skeleton from 'react-loading-skeleton';
import 'moment/locale/nl';
import moment from 'moment';
import 'moment-timezone';
import { saveAs } from "file-saver";

//styles
import './schadeDocumenten.css';
import 'react-loading-skeleton/dist/skeleton.css';


const Example = (props) => <button onClick={() => { props.fetchPdf(props.mime.includes("pdf") ? props.url : ''); props.setShowDocument(true); props.setShowSlider(false); props.setDocumentTitle(props.title); props.setImageUrl(props.mime.includes("image") ? props.url : ''); }}><Icon.ZoomIn /><span>Voorbeeld</span></button>;
const BlobExample = (props) => <button onClick={() => { props.getFileContents(props.folder, props.subfolder, props.filename); props.setShowDocument(true); props.setShowSlider(false); props.setDocumentTitle(props.title); }}><Icon.ZoomIn /><span>Voorbeeld</span></button>;
const Download = (props) => <button onClick={() => { saveAs(props.url, props.name) }}><Icon.Download /><span>Download</span></button>;
const Delete = (props) => <button onClick={() => { props.deleteDocument(props.index) }}><Icon.Trash3 /></button>;

const SchadeDocumenten = (props) => {
    
    const environment = process.env.REACT_APP_APP_URL;
    const [isLoading, setIsloading] = useState(false);
    const fileInputRef = useRef(null);
    function handleClick() {
        fileInputRef.current.value = '';
    }

    const changeOrder = (items, index, type) => {
        if (type === 'up' && index > 0) {
            // Swap current item with the previous one
            [items[index], items[index - 1]] = [items[index - 1], items[index]];
        } else if (type === 'down' && index < items.length - 1) {
            // Swap current item with the next one
            [items[index], items[index + 1]] = [items[index + 1], items[index]];
        }
        props.changeDocumentsOrder(items);
    };

    return (
        <>
        {
            props.schade ?
            <>
            {
                props.schade ?
                <div className="document-list">
                    {
                    props.schade.voorkant_schadeformulier_fs ?
                        <>
                        {
                            props.schade.schadeformulier ?
                            <div className="item"><span className="document-name">Schadeformulier</span><div className="actions"><Example mime={props.schade.schadeformulier.mime} fetchPdf={props.fetchPdf} url={environment + props.schade.schadeformulier.url} setShowDocument={props.setShowDocument} setShowSlider={props.setShowSlider} title={'Schadeformulier'} setDocumentTitle={props.setDocumentTitle} setImageUrl={props.setImageUrl} /><Download name={'schadeformulier-' + props.schade.kenmerk} url={environment + props.schade.schadeformulier.url} /></div></div>
                            :
                            <>
                            <div className="item"><span className="document-name">Voorkant schadeformulier FS</span>
                                <div className="actions">
                                    {
                                        props.schade.voorkant_schadeformulier_fs.includes('.pdf') ?
                                        <BlobExample folder={props.schade.kenmerk} subfolder={'Documenten'} filename={props.schade.voorkant_schadeformulier_fs} getFileContents={props.getFileContents} setShowDocument={props.setShowDocument} setDocumentTitle={props.setDocumentTitle} setShowSlider={props.setShowSlider} title={'Voorkant schadeformulier'} />
                                        :
                                        null
                                    }
                                    <button onClick={() => props.handleDownload(props.schade.kenmerk, 'Documenten', props.schade.voorkant_schadeformulier_fs)}>Download</button>
                                    </div>
                                </div>
                            {
                                props.schade.achterkant_schadeformulier_fs ?
                                <div className="item"><span className="document-name">Achterkant schadeformulier FS</span>
                                    <div className="actions">
                                        {
                                            props.schade.achterkant_schadeformulier_fs.includes('.pdf') ?
                                            <BlobExample folder={props.schade.kenmerk} subfolder={'Documenten'} filename={props.schade.achterkant_schadeformulier_fs} getFileContents={props.getFileContents} setShowDocument={props.setShowDocument} setDocumentTitle={props.setDocumentTitle} setShowSlider={props.setShowSlider} title={'Achterkant schadeformulier'} />
                                            :
                                            null
                                        }
                                        <button onClick={() => props.handleDownload(props.schade.kenmerk, 'Documenten', props.schade.achterkant_schadeformulier_fs)}>Download</button>
                                    </div>
                                </div>
                                :
                                null
                            }
                            </> 
                        }
                        </>
                        :
                        null
                    }
                    {
                        props.schade.chauffeursverklaring ?
                        <div className="item"><span className="document-name">Chauffeursverklaring</span>
                            <div className="actions">
                                {
                                    props.schade.chauffeursverklaring.includes('.pdf') ?
                                    <BlobExample folder={props.schade.kenmerk} subfolder={'Documenten'} filename={props.schade.chauffeursverklaring} getFileContents={props.getFileContents} setShowDocument={props.setShowDocument} setDocumentTitle={props.setDocumentTitle} setShowSlider={props.setShowSlider} title={'Chauffeursverklaring'} />
                                    :
                                    null
                                }
                                <button onClick={() => props.handleDownload(props.schade.kenmerk, 'Documenten', props.schade.chauffeursverklaring)}>Download</button>
                            </div>
                        </div>
                        :
                        null
                    }
                    {
                        props.schade.vrachtbrief ?
                        <div className="item"><span className="document-name">Vrachtbrief</span>
                            <div className="actions">
                                {
                                    props.schade.vrachtbrief.includes('.pdf') ?
                                    <BlobExample folder={props.schade.kenmerk} subfolder={'Documenten'} filename={props.schade.vrachtbrief} getFileContents={props.getFileContents} setShowDocument={props.setShowDocument} setDocumentTitle={props.setDocumentTitle} setShowSlider={props.setShowSlider} title={'Vrachtbrief'} />
                                    :
                                    null
                                }
                                <button onClick={() => props.handleDownload(props.schade.kenmerk, 'Documenten', props.schade.vrachtbrief)}>Download</button>
                            </div>
                        </div>
                        :
                        null
                    }
                    {
                        props.schade.documenten ?
                        props.schade.documenten.map((item, index) =>  {
                            if (props.schade.status.key === 'in_afwachting_wagenpark' && item.werkbon && item.oude_versie) {

                            } else {
                                return <div key={index} className="item orderlist">
                                <div className="documents-order">
                                    <Icon.ArrowUpCircleFill className={'order-icon ' + (index === 0 ? 'disabled' : '')} onClick={() => index === 0 ? null : changeOrder(props.schade.documenten, index, 'up')} />
                                    <Icon.ArrowDownCircleFill className={'order-icon ' + (index === props.schade.documenten.length - 1 ? 'disabled' : '')} onClick={() => index === props.schade.documenten.length - 1 ? null : changeOrder(props.schade.documenten, index, 'down')} />
                                </div>
                                <span className="document-name">{item.documentnaam}<span>{item.oude_versie ? 'Oude versie' : ''}</span></span>
                                <div className="actions">
                                {
                                    item.pad && item.pad.includes('.pdf') ?
                                    <BlobExample folder={props.schade.kenmerk} subfolder={'Documenten'} filename={item.pad} getFileContents={props.getFileContents} setShowDocument={props.setShowDocument} setDocumentTitle={props.setDocumentTitle} setShowSlider={props.setShowSlider} title={item.documentnaam} />
                                    :
                                    null
                                }
                                <button onClick={() => props.handleDownload(props.schade.kenmerk, 'Documenten', item.pad)}>Download</button>
                                {
                                    !item.werkbon ?
                                    <Delete deleteDocument={props.deleteDocument} index={index} />
                                    :
                                    null
                                }
                                
                                </div></div>
                            }
                        })
                        :
                        null
                    }
                </div>
                :
                <p>Geen documenten beschikbaar</p>
            }
            
            </>
            :
            <>
            <Skeleton height={20} style={{marginBottom:10}} />
            <Skeleton height={20} style={{marginBottom:10}} />
            <Skeleton height={20} style={{marginBottom:10}} />
            <Skeleton height={20} style={{marginBottom:10}} />
            </>
        }
        
        </>
    );
};
export default SchadeDocumenten;